import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { PopupProps } from "react-map-gl";
import useFlyTo, { InitiatorType } from "../hooks/useFlyTo";
import { GeoCoordinate } from "../interfaces/GeoCoordinate";
import MapPopup from "./MapPopup";

function MapPopupWithFlyTo({ children, ...props }: PopupProps) {
    const coordinates = useMemo(() => new GeoCoordinate(props.latitude, props.longitude), [props.latitude, props.longitude]);
    useFlyTo(coordinates, InitiatorType.Popup);
    
    return (
        <MapPopup {...props} >
            {children}
        </MapPopup>
    );
}

export default observer(MapPopupWithFlyTo);
